// src/features/auth/PrivateRoute.jsx
import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContexto";

export default function PrivateRoute() {
  const { usuario, token, cargandoAuth } = useContext(AuthContext) || {};
  const location = useLocation();

  if (cargandoAuth) return null;
  if (!token || !usuario) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
